<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
        <div class="lg:max-w-detaillg lg:mr-auto">

          <localization language="es-ES">
            <intl locale="es">

              <div class="flex p-1 items-center justify-center mr-4">
                <div class="flex p-1 items-center justify-center">
                  <base-button-icon 
                    v-if="isMoreLowerYear" 
                    @click="modifyYear(false)" 
                    name="chevronleft" 
                    title="Año anterior"
                    size="xs" 
                    :disabled="!totalDaysSelected || totalDaysSelected.length > 0"
                    ariaLabel="Cambiar al año anterior"
                    mode="primary-phantom" />
                  <div v-else class="w-8"></div>
                  <div class="pl-2 pr-2 dark:text-darkblue-200">Año {{form.year}}</div>
                  <base-button-icon 
                    v-if="(actualYear + 1) > form.year" 
                    @click="modifyYear(true)" 
                    name="chevronright" 
                    title="Año siguiente"
                    size="xs" 
                    :disabled="!totalDaysSelected || totalDaysSelected.length > 0"
                    ariaLabel="Cambiar al año siguiente"
                    mode="primary-phantom" />
                  <div v-else class="w-8"></div>
                </div>
              </div>
            
            <div class="flex flex-col md:flex-row md:items-center lg:mb-2">
              <div class="w-full mr-2" ref="selectRef">
                <AccessibleElSelect
                  v-model="form.companies"
                  prop="companies"
                  :options="companiesForAccessibleSelect"
                  :isMultiple="true"
                  :collapseTags="true"
                  :withFormItem="true"
                  :isDisabled="isValidated"
                  id-prefix="courtesydaysaeat"
                >
                  <template slot="label">{{$t('app.companies')}}</template>
                </AccessibleElSelect>
              </div>
              <div class="mr-2">
                <base-button mode='primary' 
                  class="w-48" 
                  v-if="!isAllSelected && !isValidated" 
                  :disabled="isGeneralLoading || isLoadingSelect || isEmptyList || isValidated" 
                  :text="$t('app.select_all')" 
                  @click="handleSelectAll" 
                  :loading="isGeneralLoading"
                  />
                <base-button 
                  v-if="isAllSelected && !isValidated" 
                  :text="$t('app.unselect_all')" 
                  class="w-48" 
                  @click="handleUnSelectAll"
                  :loading="isGeneralLoading"
                  :disabled="isGeneralLoading || isLoadingSelect || isEmptyList || isValidated"
                  />
              </div>
              <div class="mt-2 md:mt-0 mb-2 md:mb-0">
                <base-button
                  v-if="!isValidated"
                  @click.prevent.stop="validateCompanies()"
                  class="w-32" 
                  mode="primary" 
                  :text="$t('app.validate')" 
                  :loading="isGeneralLoading" 
                  :disabled="isGeneralLoading"/>
                <base-button
                  v-if="isValidated"
                  @click.prevent.stop="modifyCompanies()"
                  class="w-32" 
                  mode="primary" 
                  :text="$t('app.modify')" 
                  :loading="isGeneralLoading" 
                  :disabled="isGeneralLoading"/>
              </div>
                <div class="w-56"/>
              </div>

              <ul class="lg:mb-4 w-full flex -mx-2 flex-col lg:flex-row">
                <li class="px-2 mb-2 lg:mb-0 flex">
                  <base-ro-input-minimal :label="$t('courtesy_days_aeat.days_pendientes') + ': ' + selectedPendingDays" />
                </li>
                <li class="px-2 mb-2 lg:mb-0 flex">
                  <base-ro-input-minimal :label="$t('courtesy_days_aeat.days_solicitados') + ' en alguna empresa: ' + selectedSolicitDays" />
                  <div class=" ml-2 h-5 w-5 bg-primary-800 border border-solid border-darkblue-600 rounded-full"/>
                </li>
                <li class="px-2 mb-2 lg:mb-0 flex">
                  <base-ro-input-minimal :label="$t('courtesy_days_aeat.days_solicitados_rep') + ': ' + selectedSolicitDaysRep" />
                  <div class=" ml-2 h-5 w-5 bg-secondary-600 border border-solid border-darkblue-600 "/>
                </li>
              </ul>

              
              <div class="vld-parent">
                <loading :opacity="darkMode ? 0 : 0.5" :active="false" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
                <div v-if="!loadingCalendar"  class="flex flex-wrap">
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Enero</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 1"
                      ref="calendar1"
                      @change="onChangeCalendar1"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month1"
                      :navigation="false"
                      :min="new Date(form.year, 0, lastEnableMonth === 1 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 0, 31)"
                      />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Febrero</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 2"
                      ref="calendar2"
                      @change="onChangeCalendar2"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month2"
                      :navigation="false"
                      :min="new Date(form.year, 1, lastEnableMonth === 2 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 1, esBisiestoActual ? 29 : 28)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Marzo</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 3"
                      ref="calendar3"
                      @change="onChangeCalendar3"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month3"
                      :navigation="false"
                      :min="new Date(form.year, 2, lastEnableMonth === 3 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 2, 31)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Abril</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 4"
                      ref="calendar4"
                      @change="onChangeCalendar4"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month4"
                      :navigation="false"
                      :min="new Date(form.year, 3, lastEnableMonth === 4 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 3, 30)"
                    />
                  </div>
                
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Mayo</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 5"
                      ref="calendar5"
                      @change="onChangeCalendar5"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month5"
                      :navigation="false"
                      :min="new Date(form.year, 4, lastEnableMonth === 5 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 4, 31)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Junio</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 6"
                      ref="calendar6"
                      @change="onChangeCalendar6"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month6"
                      :navigation="false"
                      :min="new Date(form.year, 5, lastEnableMonth === 6 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 5, 30)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Julio</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 7"
                      ref="calendar7"
                      @change="onChangeCalendar7"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month7"
                      :navigation="false"
                      :min="new Date(form.year, 6, lastEnableMonth === 7 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 6, 31)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Agosto</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 8"
                      ref="calendar8"
                      @change="onChangeCalendar8"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month8"
                      :navigation="false"
                      :min="new Date(form.year, 7, lastEnableMonth === 8 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 7, 31)"
                    />
                  </div>
                
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Septiembre</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 9"
                      ref="calendar9"
                      @change="onChangeCalendar9"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month9"
                      :navigation="false"
                      :min="new Date(form.year, 8, lastEnableMonth === 9 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 8, 30)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Octubre</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 10"
                      ref="calendar10"
                      @change="onChangeCalendar10"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month10"
                      :navigation="false"
                      :min="new Date(form.year, 9, lastEnableMonth === 10 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 9, 31)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Noviembre</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 11"
                      ref="calendar11"
                      @change="onChangeCalendar11"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month11"
                      :navigation="false"
                      :min="new Date(form.year, 10, lastEnableMonth === 11 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 10, 30)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Diciembre</h2>
                    <calendar
                      :disabled="!isValidated || disableOnlySolicitud || lastEnableMonth > 12"
                      ref="calendar12"
                      @change="onChangeCalendar12"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month12"
                      :navigation="false"
                      :min="new Date(form.year, 11, lastEnableMonth === 12 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 11, 31)"
                    />
                  </div>
                </div>
              </div>

          </intl>
        </localization>
        </div>
        </el-form>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive 
            v-if="isValidated && isAnyDaySelected && !disableOnlySolicitud" 
            @click="sendVacaciones()" 
            mode="primary" 
            :text="$t('app.solicitar')" 
            icon="plus" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
          <base-button-responsive 
            v-if="isValidated" 
            @click="checkVacaciones()" 
            mode="primary" 
            :text="$t('app.consult_days_aeat')" 
            icon="check" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import Loading from 'vue-loading-overlay'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

import { getAllCompanies } from '@/services/companies/getAllCompanies'
import { getClient } from '@/services/clients/getClient'
import { validateSendDaysCourtesyAEATMultiple } from '@/services/companies/validateSendDaysCourtesyAEATMultiple'
import { checkSendDaysCourtesyAEATMultiple } from '@/services/companies/checkSendDaysCourtesyAEATMultiple'
import { sendDaysCourtesyAEATMultiple } from '@/services/companies/sendDaysCourtesyAEATMultiple'

import { i18n } from '@/i18n'
import { Calendar } from '@progress/kendo-vue-dateinputs'
import { IntlProvider, LocalizationProvider } from '@progress/kendo-vue-intl'
import { ESTADOS_DIAS_CORTESIA } from '@/config/estados-dias-cortesia'
// import Cell from '../../components/kendo/calendar/Cell.vue'
// import { IntlProvider, loadMessages, LocalizationProvider } from '@progress/kendo-vue-intl'
// import esMessages from './es.json'

// loadMessages(esMessages, 'es-ES')

function getElementByXpath (path) {
  return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue
}

export default {
  /* eslint-disable camelcase */
  name: 'courtesy-days-client-detail',
  components: {
    DetailLayoutFullWidth,
    calendar: Calendar,
    localization: LocalizationProvider,
    intl: IntlProvider,
    Loading,
    AccessibleElSelect,
    // custom: Cell,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('clients.courtesydaysaeat_header_text'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/general'
      },
      isValidated: false,
      disableOnlySolicitud: false,

      loadingActionSelect: false,
      loadingActionUnSelect: false,
      loadingCalendar: false,
      customCell: 'myTemplate',
      estadosDiasCortesia: ESTADOS_DIAS_CORTESIA,
      actualYear: new Date().getFullYear(),
      focusedDates: {
        month1: new Date(new Date().getFullYear(), 0, 1),
        month2: new Date(new Date().getFullYear(), 1, 1),
        month3: new Date(new Date().getFullYear(), 2, 1),
        month4: new Date(new Date().getFullYear(), 3, 1),
        month5: new Date(new Date().getFullYear(), 4, 1),
        month6: new Date(new Date().getFullYear(), 5, 1),
        month7: new Date(new Date().getFullYear(), 6, 1),
        month8: new Date(new Date().getFullYear(), 7, 1),
        month9: new Date(new Date().getFullYear(), 8, 1),
        month10: new Date(new Date().getFullYear(), 9, 1),
        month11: new Date(new Date().getFullYear(), 10, 1),
        month12: new Date(new Date().getFullYear(), 11, 1),
      },
      companies: [],
      form: {
        companies: [],
        
        year: 2000,
        datesMonth1: [],
        datesMonth2: [],
        datesMonth3: [],
        datesMonth4: [],
        datesMonth5: [],
        datesMonth6: [],
        datesMonth7: [],
        datesMonth8: [],
        datesMonth9: [],
        datesMonth10: [],
        datesMonth11: [],
        datesMonth12: [],
      },
      estadoActual: {
        // Año actual
        pendingDays1: 0,
        solicitDays1: 0,
        solicitDaysRep1: 0,

        // Año siguiente
        pendingDays2: 0,
        solicitDays2: 0,
        solicitDaysRep2: 0,

        datesAprovados: [],
        datesRepetidas: [],
      },
      rules: {
      }
    }
  },
  computed: {
    lastEnableMonth () {
      if (this.isYearActual) return new Date(new Date().setDate(new Date().getDate() + 7)).getMonth() + 1
      return -1
    },
    lastEnableDay () {
      return new Date(new Date().setDate(new Date().getDate() + 7)).getDate() + 1
    },
    esBisiestoActual () {
      return (this.form?.year % 4 === 0 && this.form?.year % 100 !== 0) || (this.form?.year % 400 === 0)
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },

    isAllSelected: function () {
      if (this.companies.length === this.form.companies.length) return true
      else return false
    },
    isEmptyList: function () {
      return this.companies === undefined || this.companies === null || this.companies.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },

    selectedPendingDays () {
      if (!this.form.year) return 0
      if (this.form.year === this.actualYear) return this.estadoActual.pendingDays1
      return this.estadoActual.pendingDays2
    },
    selectedSolicitDays () {
      if (!this.form.year) return 0
      if (this.form.year === this.actualYear) return this.estadoActual.solicitDays1
      return this.estadoActual.solicitDays2
    },
    selectedSolicitDaysRep () {
      if (!this.form.year) return 0
      if (this.form.year === this.actualYear) return this.estadoActual.solicitDaysRep1
      return this.estadoActual.solicitDaysRep2
    },
    
    selectedDatesAprobados () {
      if (!this.form.year) return []
      return this.estadoActual.datesAprovados
    },
    selectedDatesRepetidas () {
      if (!this.form.year) return []
      return this.estadoActual.datesRepetidas
    },
    
    totalDaysSelected () {
      const fechas = this.form.datesMonth1
        .concat(this.form.datesMonth2)
        .concat(this.form.datesMonth3)
        .concat(this.form.datesMonth4)
        .concat(this.form.datesMonth5)
        .concat(this.form.datesMonth6)
        .concat(this.form.datesMonth7)
        .concat(this.form.datesMonth8)
        .concat(this.form.datesMonth9)
        .concat(this.form.datesMonth10)
        .concat(this.form.datesMonth11)
        .concat(this.form.datesMonth12)
      return fechas.map(x => this.formatToUTC(x))
    },
    companiesForAccessibleSelect () {
      return this.companies.map(company => ({
        id: company.id,
        name: company.label,
        value: company.id
      }))
    },
    isAnyDaySelected () {
      return this.totalDaysSelected.length > 0
    },
    isYearActual () {
      return this.actualYear === this.form.year
    },
    isMoreLowerYear () {
      if (this.form.year > this.actualYear) return true
      return false
    },
    pendingDaysActual () {
      return this.selectedPendingDays
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.year': function (value, oldValue) {
      this.isValidated = false
      this.form.companies = []
      this.onChangeYear(value)
    }
  },
  created: async function () {
    this.form.year = new Date().getFullYear()
    const clientId = this.$route.params.id
    const breadcrumbs = []

    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      this.header.url = 'configurations/clients/details'
      breadcrumbs.push({
        path: 'configurationssa',
        name: this.$i18n.t('app.configurations')
      })
      breadcrumbs.push({
        path: 'configurations/clients',
        name: this.$i18n.t('app.clients')
      })
      if (clientId !== -1) {
        if (this.$store.getters['app/fromRouteName'] !== null) {
          const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
          breadcrumbs.push({ path: '', name: breadcrumbHeader })
        } else {
          const cliente = await this.downloadClientData(clientId)
          breadcrumbs.push({ path: '', name: cliente.empresa.Nombre })
          this.$store.commit('app/setheaderBreadCrumb', cliente.empresa.Nombre)
        }
      }
    }

    this.header.breadcrumb = breadcrumbs

    const params = { idEmpresaCert: clientId }
    const dataCompanies = await getAllCompanies(params)
    if (dataCompanies.blnError === true) {
      this.doFeedback(dataCompanies.msgError + ' [Código de error: ' + dataCompanies.codError + ']')
    } else {
      dataCompanies.CIFSEmpresa.forEach(row => {
        this.companies.push({ id: row.IdCIFEmpresa, label: row.CIF + ' - ' + row.NombreCIF })
      })
    }

    if (this.$route.params.data) {
      this.filterByParamsData()
    }

    // const data = await this.downloadData(clientId)
    // this.setData(data.respuesta)
    // setTimeout(() => {
    //   this.markSelected()
    // }, 200)
  },
  methods: {
    formatToUTC (date) {
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()))
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'companies') {
            this.form.companies = filter.data
          }
        })
        this.validateCompanies()
      }
    },
    validateCompanies: async function () {
      // this.isValidated = true
      if (this.form.companies === null || this.form.companies.length === 0) {
        this.doFeedback('Es necesario seleccionar empresas para poder validar', 'info')
        return
      }
      try {
        this.$store.commit('setIsLoading', true)
        const response = await validateSendDaysCourtesyAEATMultiple({ Year: this.form.year }, this.form.companies)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Empresas validadas correctamente', 'success')
          if (response.Respuesta === 1) {
            this.disableOnlySolicitud = true
            setTimeout(() => {
              this.doFeedback('Es necesario actualizar la información para realizar solicitudes', 'info')
            }, 100)
          }
          this.setData(response.DatosVacaciones)
          this.isValidated = true
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    sendVacaciones: async function (retry) {
      if (this.totalDaysSelected.length > this.pendingDaysActual) {
        this.doFeedback('Se ha excedido el número de días a solicitar')
        return
      }
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          idCifEmpresas: this.form.companies,
          Fechas: this.totalDaysSelected,
        }
        const response = await sendDaysCourtesyAEATMultiple(null, payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Se han generado solicitudes de días y se ha actualizado la información correctamente', 'success')
          this.modifyCompanies()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    checkVacaciones: async function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const response = await checkSendDaysCourtesyAEATMultiple({ Year: this.form.year }, this.form.companies)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Se han generado consultas correctamente', 'success')
          this.modifyCompanies()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    modifyCompanies () {
      this.isValidated = false
      this.disableOnlySolicitud = false
      this.form.companies = []
      this.onChangeYear(this.form.year)
    },
    getDatesBetween (startDate, stopDate) {
      const dateArray = []
      let currentDate = startDate
      while (currentDate <= stopDate) {
        dateArray.push(new Date(currentDate))
        currentDate = new Date(currentDate.setDate(new Date(currentDate).getDate() + 1))
      }
      return dateArray
    },
    markSelected () {
      // Desactivados dias por defecto antiguos
      // if (this.isYearActual) {
      //   const disabledDefault = this.getDatesBetween(new Date(this.actualYear, 0, 1), new Date(new Date().setDate(new Date().getDate() + 7)))
      //   disabledDefault.forEach(x => {
      //     this.markDay(x.getMonth() + 1, x.getDate(), 0)
      //   })
      // }
      // Marcar dias aprobados y pendientes
      this.selectedDatesAprobados.forEach(x => {
        if (x.getFullYear() === this.form.year) {
          this.markDay(x.getMonth() + 1, x.getDate(), 1)
        }
      })
      // Marcar días repetidos
      this.selectedDatesRepetidas.forEach(x => {
        if (x.getFullYear() === this.form.year) {
          this.markDay(x.getMonth() + 1, x.getDate(), 2)
        }
      })
    },
    // Status: 0 => Deshabilitada, 1 => Repetida, 2 => Aprobada
    markDay (mes, dia, status) {
      const query = `(//tbody[contains(@class, "k-calendar-tbody")])[${mes}]/tr/td/span[text() = ${dia}]`
      const queryTd = `(//tbody[contains(@class, "k-calendar-tbody")])[${mes}]/tr/td[span[text() = ${dia}]]`
      const spanSelected = getElementByXpath(query)
      const tdSelected = getElementByXpath(queryTd)
      if (status === 0) {
        // tdSelected.classList.add('k-disabled')
        // tdSelected.setAttribute('style', 'outline: none!important; cursor: default!important; opacity: 0.8!important; filter: grayscale(0.1)!important; pointer-events: none!important; box-shadow: none!important;')
      } else if (status === 1) {
        if (this.lastEnableMonth > mes) {
          spanSelected.setAttribute('style', 'background-color: var(--primary-900); color: white !important; border-radius:20px!important')
        } else {
          spanSelected.setAttribute('style', 'background-color: var(--primary-800); color: white !important; border-radius:20px!important')
        }
        tdSelected.setAttribute('style', 'outline: none!important; cursor: default!important; opacity: 0.8!important; filter: grayscale(0.1)!important; pointer-events: none!important; box-shadow: none!important;')
      } else if (status === 2) {
        spanSelected.setAttribute('style', 'background-color: var(--secondary-DEFAULT); color: white !important; ')
        tdSelected.setAttribute('style', 'outline: none!important; cursor: default!important; opacity: 0.8!important; filter: grayscale(0.1)!important; pointer-events: none!important; box-shadow: none!important;')
      }
    },
    onChangeCalendar1 (value) { this.form.datesMonth1 = value.value },
    onChangeCalendar2 (value) { this.form.datesMonth2 = value.value },
    onChangeCalendar3 (value) { this.form.datesMonth3 = value.value },
    onChangeCalendar4 (value) { this.form.datesMonth4 = value.value },
    onChangeCalendar5 (value) { this.form.datesMonth5 = value.value },
    onChangeCalendar6 (value) { this.form.datesMonth6 = value.value },
    onChangeCalendar7 (value) { this.form.datesMonth7 = value.value },
    onChangeCalendar8 (value) { this.form.datesMonth8 = value.value },
    onChangeCalendar9 (value) { this.form.datesMonth9 = value.value },
    onChangeCalendar10 (value) { this.form.datesMonth10 = value.value },
    onChangeCalendar11 (value) { this.form.datesMonth11 = value.value },
    onChangeCalendar12 (value) { this.form.datesMonth12 = value.value },
    modifyYear (add) {
      if (add) this.form.year = this.form.year + 1
      else this.form.year = this.form.year - 1
    },
    onChangeYear (newYear) {
      this.cleanValuesMonths()
      this.estadoActual.solicitDays1 = 0
      this.estadoActual.solicitDaysRep1 = 0
      this.estadoActual.pendingDays1 = 0
      this.estadoActual.solicitDays2 = 0
      this.estadoActual.solicitDaysRep2 = 0
      this.estadoActual.pendingDays2 = 0
      this.estadoActual.datesAprovados = []
      this.estadoActual.datesRepetidas = []
      this.loadingCalendar = true
      this.focusedDates.month1.setFullYear(newYear)
      this.focusedDates.month2.setFullYear(newYear)
      this.focusedDates.month3.setFullYear(newYear)
      this.focusedDates.month4.setFullYear(newYear)
      this.focusedDates.month5.setFullYear(newYear)
      this.focusedDates.month6.setFullYear(newYear)
      this.focusedDates.month7.setFullYear(newYear)
      this.focusedDates.month8.setFullYear(newYear)
      this.focusedDates.month9.setFullYear(newYear)
      this.focusedDates.month10.setFullYear(newYear)
      this.focusedDates.month11.setFullYear(newYear)
      this.focusedDates.month12.setFullYear(newYear)
      setTimeout(() => {
        this.loadingCalendar = false
      }, 100)
      setTimeout(() => {
        this.markSelected()
      }, 200)
    },
    cleanValuesMonths () {
      this.form.datesMonth1 = []
      this.form.datesMonth2 = []
      this.form.datesMonth3 = []
      this.form.datesMonth4 = []
      this.form.datesMonth5 = []
      this.form.datesMonth6 = []
      this.form.datesMonth7 = []
      this.form.datesMonth8 = []
      this.form.datesMonth9 = []
      this.form.datesMonth10 = []
      this.form.datesMonth11 = []
      this.form.datesMonth12 = []
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(client.msgError + ' [Código de error: ' + client.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    watchFormHandler: function ({ certificate, send_alerts, automatic_download, fechaInicioVig }) {
    },
    goBack: function () {
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') this.$router.push({ name: 'configurations/clients/details', params: this.$route.params.id })
      else this.$router.push({ name: 'configurations/general' })
    },
    setData: function (data) {
      if (data) {
        if (data.Year === this.actualYear) {
          this.estadoActual.solicitDays1 = data.FechasAprobadas ? data.FechasAprobadas.length : 0
          this.estadoActual.solicitDaysRep1 = data.FechasRepetidas ? data.FechasRepetidas.length : 0
          this.estadoActual.pendingDays1 = data.DiasDisponibles ? data.DiasDisponibles : 0
        } else {
          this.estadoActual.solicitDays2 = data.FechasAprobadas ? data.FechasAprobadas.length : 0
          this.estadoActual.solicitDaysRep2 = data.FechasRepetidas ? data.FechasRepetidas.length : 0
          this.estadoActual.pendingDays2 = data.DiasDisponibles ? data.DiasDisponibles : 0
        }
        this.estadoActual.datesAprovados = data.FechasAprobadas ? data.FechasAprobadas.map(x => new Date(x)) : []
        this.estadoActual.datesRepetidas = data.FechasRepetidas ? data.FechasRepetidas.map(x => new Date(x)) : []
      }
      setTimeout(() => {
        this.markSelected()
      }, 200)
      // this.form.year = new Date().getFullYear()
    },
    
    handleSelectAll: async function () {
      // this.form.location = []
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.companies.forEach(element => {
        setTimeout(() => {
          this.form.companies.push(element.id)
          if (this.form.companies.length === this.companies.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.companies.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.companies.pop()
          if (this.form.companies.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    },
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
